export class PlantInvoiceDetailsRequest {
    saleOrderId?: number;


    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}